import { HorizontalLinkGroup } from 'components/navigation';
import { useUserHasAccess } from 'hooks/useUserHasAccess';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';

export function Layout(props) {

    const userHasAccess = useUserHasAccess();

    const routes = useMemo(() => {
        return [
            { location: `/employee/${props.employeeId}/documents/document-list`, title: "All Documents", permission: "Documents:View" },
            { location: `/employee/${props.employeeId}/documents/policies`, title: "Policies", permission: "Documents:View" },
        ]
            .filter(r => !r.permission || userHasAccess(r.permission))
    }, [props.employeeId, userHasAccess]);

    return (
        <Fragment>
            <div className="row">
                <div className="spacer-bottom-medium">
                    <HorizontalLinkGroup links={routes} exactRouteMatch={true}></HorizontalLinkGroup>
                </div>
            </div>

            <div className='row'>
                {props.children}
            </div>
        </Fragment>
    );
}

Layout.propTypes = {
    employeeId: PropTypes.number,
    children: PropTypes.node
};
